import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9ad9a2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-control umbraco-form__title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed, PropType } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormTitleAndDescription',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const captionHtml = computed(() => {
  return `<${props.field?.settings.captionTag}>${props.field?.settings.caption}</<${props.field?.settings.captionTag}>`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.field.settings.captionTag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: __props.field.settings.caption
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: captionHtml.value
        }, null, 8, _hoisted_3)),
    _createElementVNode("div", {
      innerHTML: __props.field.settings.bodyText
    }, null, 8, _hoisted_4)
  ]))
}
}

})